import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import OrderCreatePageUI from './OrderCreatePageUI.js'

class OrderCreatePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <OrderCreatePageUI
        context={this.props.context}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'})
  }

  getMessages(context) {
    let arr = [
      'c_expected_margin',
      'c_create_order',
      'c_order_name',
      'c_due_date',
      'c_customer',
      'c_create',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_ord_crt', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }

}

export default OrderCreatePageSF
